import VueCookies from 'vue-cookies';

import config from '@/../config/build-config';
import analyticsUtils from '@/core/analytics/analytics-utils';

// Modules
import OneTimePassStore from '@/portal/one-time-pass/one-time-pass.store';
import WorkerOnBoardingStore from '@/portal/worker-on-boarding/worker-on-boarding.store';

const { cookieDomain, authTokenName } = config;

export default {
  modules: {
    oneTimePass: OneTimePassStore,
    workerOnBoarding: WorkerOnBoardingStore,
  },
  state: {
    config,
    authToken: VueCookies.get(authTokenName),
    pageTitle: '',
    user: null,
    vendorUser: null,
    worker: null,
  },
  mutations: {
    setAuthToken(state, authToken, expires) {
      state.authToken = authToken;
      VueCookies.set(authTokenName, authToken, expires, null, cookieDomain);
    },
    removeAuthToken(state) {
      state.authToken = null;
      VueCookies.remove(authTokenName, null, cookieDomain);
    },
    setUser(state, user) {
      state.user = user;
      analyticsUtils.identifyUser(user);
    },
    resetUser(state) {
      state.user = null;
    },
    setVendorUser(state, vendorUser) {
      state.vendorUser = vendorUser;
    },
    setWorker(state, worker) {
      state.worker = worker;
    },
    setPageTitle(state, pageTitle) {
      const title = pageTitle ? `${pageTitle} | iPRO` : 'iPRO';
      state.pageTitle = title;
      document.title = title;
    },
  },
  getters: {
    hasAuthToken: state => !!state.authToken,
    umBaseUrl: state => `${state.config.endpoints.um.endpoint}/v${state.config.endpoints.um.version}`,
    userFullName: state => [_.get(state, 'user.first_name'), _.get(state, 'user.last_name')].filter(v => v).join(' '),
    vmBaseUrl: state => `${state.config.endpoints.vm.endpoint}/v${state.config.endpoints.vm.version}`,
    dnaBaseUrl: state => state.config.endpoints.dna.endpoint,
  },
};
